export type ContentImageSourceType =
  | "unknown" // Pre-existing rows with no known origin
  | "user_upload" // Direct file upload from Content Library UI
  | "dam_import" // External DAM (Canto, Orange Logic, Aprimo, Adobe AEM)
  | "figma_import" // Promoted out of a Figma staged import draft
  | "agent_chat_output" // Saved from agent chat (markdown images, artifact images)
  | "email_output" // Saved from email/message preview
  | "template_output" // Saved from an uploaded template
  | "web_crawl" // Brand kit web crawl, product scrape, ad fetch
  | "svg_editor" // Saved from SVG image editor
  | "html_editor" // Saved from HTML image editor
  | "ad_studio_output" // Rendered Ad Studio ad saved to the library
  | "cep"; // CEP image upload (push app icons, etc.)

export const ContentImageSource = {
  UNKNOWN: "unknown",
  USER_UPLOAD: "user_upload",
  DAM_IMPORT: "dam_import",
  FIGMA_IMPORT: "figma_import",
  AGENT_CHAT_OUTPUT: "agent_chat_output",
  EMAIL_OUTPUT: "email_output",
  TEMPLATE_OUTPUT: "template_output",
  WEB_CRAWL: "web_crawl",
  SVG_EDITOR: "svg_editor",
  HTML_EDITOR: "html_editor",
  AD_STUDIO_OUTPUT: "ad_studio_output",
  CEP: "cep",
} as const satisfies Record<string, ContentImageSourceType>;
